export function timestamp() {
    return Date.now();
}

export function timestampDiffSeconds(firstTimestamp, secondTimestamp) {
    let milliSecDiff = (new Date(secondTimestamp)).getTime() - (new Date(firstTimestamp)).getTime();
    let diff = Math.floor(milliSecDiff / 1000 / 60);
    return diff;
}
